/**
 * RevenueSimulatorPage — Simulation CA / coût / marge.
 *
 * Route : /ops/pricing/simulator
 *
 * Accès : ROLE_PLATFORM_ADMIN.
 */

import { Button } from 'antd';
import { ArrowLeft, Calculator } from 'lucide-react';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import RevenueSimulator from '@/components/pricing/RevenueSimulator';

const RevenueSimulatorPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="fc-gradient-header flex items-center justify-between rounded-2xl p-6 text-white">
        <div className="flex items-center gap-3">
          <Calculator className="h-6 w-6" />
          <div>
            <h1 className="text-xl font-bold">Simulateur de revenu</h1>
            <p className="mt-1 text-sm text-blue-100">
              CA brut · coût upstream · marge nette — simulation mensuelle
            </p>
          </div>
        </div>
        <Button
          ghost
          icon={<ArrowLeft className="h-4 w-4" />}
          onClick={() => navigate('/ops/pricing')}
        >
          Retour
        </Button>
      </div>

      <RevenueSimulator />
    </div>
  );
};

export default RevenueSimulatorPage;
